export default class LimitModel {
    constructor() {
        this.dailyVisitLimit = undefined;
        this.monthlyAmountLimit = undefined;
        this.fuelQuantityLimit = undefined;
        this.fuelAmountLimit = undefined;
        this.notFuelAmountLimit = undefined;
        this.serviceAmountLimit = undefined;
        this.fleetGoodGroups = [];
        this.petrols = [];
        this.services = [];
        this.products = [];
    }

    static assign(from, to) {
        if (from) {
            to.dailyVisitLimit = from.dailyVisitLimit ? from.dailyVisitLimit : 0;
            to.monthlyAmountLimit = from.monthlyAmountLimit ? from.monthlyAmountLimit : 0;

            to.fuelQuantityLimit = from.fuelQuantityLimit
                ? JSON.parse(JSON.stringify(from.fuelQuantityLimit))
                : {type: undefined, value: undefined};
            to.fuelAmountLimit = from.fuelAmountLimit
                ? JSON.parse(JSON.stringify(from.fuelAmountLimit))
                : {type: undefined, value: undefined};
            to.notFuelAmountLimit = from.notFuelAmountLimit
                ? JSON.parse(JSON.stringify(from.notFuelAmountLimit))
                : {type: undefined, value: undefined};
            to.serviceAmountLimit = from.serviceAmountLimit
                ? JSON.parse(JSON.stringify(from.serviceAmountLimit))
                : {type: undefined, value: undefined};

            to.fleetGoodGroups = from.fleetGoodGroups ? JSON.parse(JSON.stringify(from.fleetGoodGroups)) : [];
            to.products = from.products ? JSON.parse(JSON.stringify(from.products)) : [];
            to.petrols = from.petrols ? JSON.parse(JSON.stringify(from.petrols)) : [];
            to.services = from.services ? JSON.parse(JSON.stringify(from.services)) : [];
        } else {
            to = new LimitModel();
        }
    }

    static copy(from) {
        const to = new LimitModel();
        LimitModel.assign(from, to);
        return to;
    }
}
